<div class="container-fluid project-review">
  <div class="project-wrapper"
       [ngClass]="{'is-open': menuOpen, 'collapsed': !menuOpen}">

    <!-- ======= LEFT SIDEBAR: Project Menu ======= -->
    <div class="project-menu">
      <div class="project-title">
        <div class="menu-bars"
             [ngClass]="{'is-active': menuOpen}"
             (click)="toggleMenu()">
          <div class="menu-bars-box">
            <div class="menu-bars-inner"></div>
          </div>
        </div>
        <span class="font-bold">Project Name</span>
      </div>

      <!-- Search Box -->
      <div class="project-search-container">
        <span class="glyphicon glyphicon-search search-icon"
              [ngClass]="{'dark': mouseOverSearchBox}"></span>
        <input placeholder="Search" type="text" class="search-box"
               [(ngModel)]="projectSearchTerm"
               (mouseenter)="mouseOverSearchBox = true"
               (mouseleave)="mouseOverSearchBox = false" />
      </div>

      <!-- Project List -->
      <div class="project-list-container">
        @if (projectListLoading) {
<div class="project-list-loader flex-center">
          <span>Loading...</span>
        </div>
}
        @if (!projectListLoading) {
<ul class="project-list">
          @for (project of filteredProjectList; track $index) {
<li
              [ngClass]="{'selected': project.selected}"
              (click)="selectProject(project)">
            @if (menuOpen) {
<span [id]="project.project_id">
              {{project.project_name}}
            </span>
}
            @if (!menuOpen) {
<span class="text-uppercase"
                  [title]="project.project_name">
              {{project.label}}
            </span>
}
          </li>
}
        </ul>
}
      </div>
    </div>

    <!-- ======= RIGHT: Project Details ======= -->
    <div class="project-details">

      <!-- Tab Buttons Header -->
      <div class="btn-group right-header">
        <button id="transaction-step"
                class="project-header-btn btn-md"
                (click)="selectTab(0)"
                [ngClass]="{'project-header-btn--active': tableIndex === 0}">
          Transaction By Step
        </button>
        <button id="transaction-data"
                class="project-header-btn btn-md"
                (click)="selectTab(1)"
                [ngClass]="{'project-header-btn--active': tableIndex === 1}">
          Transaction Data
        </button>
      </div>

      <!-- No Project Selected -->
      @if (!selectedProject) {
<div class="project-details-no-selection flex-center">
        <span>Please select a project from the list.</span>
      </div>
}

      <!-- Table Container -->
      @if (selectedProject) {
<div class="project-table-container">

        <!-- Loading Spinner -->
        @if (tableLoading) {
<div class="project-details-loader-container flex-center">
          <div><i class="fa fa-spinner fa-spin project-details-loader"></i></div>
        </div>
}

        <!-- ====== TAB 0: Transaction By Step ====== -->
        @if (!tableLoading && tableIndex === 0 && transByStepData.length > 0) {
<div class="project-review-datatable">
          <div class="grid-wrapper">
            <table class="table table-bordered table-hover project-table">
              <thead>
                <tr>
                  <th style="width: 30px;"></th>
                  <th style="width: 100px; cursor: pointer;" (click)="sortStepTable('step_label')">
                    Step Number
                    <i class="fa" [ngClass]="stepSortColumn === 'step_label' ? (stepSortAsc ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'" style="margin-left: 4px;"></i>
                  </th>
                  <th style="cursor: pointer;" (click)="sortStepTable('step_name')">
                    Step Name
                    <i class="fa" [ngClass]="stepSortColumn === 'step_name' ? (stepSortAsc ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'" style="margin-left: 4px;"></i>
                  </th>
                  <th style="cursor: pointer;" (click)="sortStepTable('step_description')">
                    Step Description
                    <i class="fa" [ngClass]="stepSortColumn === 'step_description' ? (stepSortAsc ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'" style="margin-left: 4px;"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (step of transByStepData; track $index; let odd = $odd) {

                  <!-- Parent Row -->
                  <tr [ngClass]="{'table-even-clr': odd, 'expanded-row': step.expanded}"
                      (click)="toggleStepExpand(step)"
                      [style.cursor]="step.has_transaction === 'true' ? 'pointer' : 'default'">
                    @if (step.has_transaction === 'true') {
<td class="details-control">
                      <i class="fa" [ngClass]="step.expanded ? 'fa-minus-square-o' : 'fa-plus-square-o'" style="color: #337ab7;"></i>
                    </td>
}
                    @if (step.has_transaction !== 'true') {
<td></td>
}
                    <td class="data-column">{{step.step_label}}</td>
                    <td class="data-column">{{step.step_name}}</td>
                    <td class="data-column">{{step.step_description}}</td>
                  </tr>
                  <!-- Child Table (expanded) -->
                  @if (step.expanded) {
<tr class="child-row">
                    <td colspan="4" style="padding: 0;">
                      <div class="child-table-container">
                        @if (step.childLoading) {
<div class="child-loading flex-center">
                          <i class="fa fa-spinner fa-spin"></i> Loading transactions...
                        </div>
}
                        @if (!step.childLoading && step.childData && step.childData.length > 0) {
<table class="table table-bordered table-hover child-table">
                          <thead>
                            <tr>
                              <th style="width: 70px;">Leid/CDR No/Rep Pd</th>
                              <th style="width: 200px;">Entity Name</th>
                              <th style="width: 40px;" class="text-center">BSLA</th>
                              <th style="width: 40px;" class="text-center">Source</th>
                              <th style="width: 200px;">Adj. Desc</th>
                              <th style="width: 200px;">Usr. Desc</th>
                              <th style="width: 30px;" class="text-center">Curr.</th>
                              <th style="width: 10px;" class="text-center">FG</th>
                              <th style="width: 80px;">Amount - Incr/ (Decr)</th>
                              <th style="width: 30px;">Docs</th>
                              <th style="width: 300px;">DST</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (row of step.childData; track $index; let childOdd = $odd) {
<tr [ngClass]="{'table-even-clr': childOdd}">
                              <td class="data-column">{{row.entity_details}}</td>
                              <td class="data-column">{{row.le_name}}</td>
                              <td class="data-column text-center">{{row.me_code}}</td>
                              <td class="data-column text-center">{{row.source_system_flag}}</td>
                              <td class="data-column">{{row.adj_desc}}</td>
                              <td class="data-column">{{row.user_desc}}</td>
                              <td class="data-column text-center">{{row.curr}}</td>
                              <td class="data-column text-center">{{row.consol_group_key}}</td>
                              <td class="data-column">
                                <span [ngClass]="{'amount-negative': isNegative(row.amount)}" class="datatable-revenue">
                                  {{formatAmount(row.amount)}}
                                </span>
                              </td>
                              <td class="data-column">
                                @if (row.source_system_flag !== 'DST' && row.doc_key) {
<span class="doc-icon text-right"
                                     
                                      (click)="downloadDocument(row.doc_key); $event.stopPropagation();">
                                  <i class="fa fa-paperclip doc-download"></i>
                                </span>
}
                              </td>
                              <td class="data-column text-link">
                                @if (row.statement_name) {
<a [href]="getDstLink(row)">
                                  &sect;&nbsp;{{row.statement_name}}
                                </a>
}
                              </td>
                            </tr>
}
                          </tbody>
                        </table>
}
                        @if (!step.childLoading && (!step.childData || step.childData.length === 0)) {
<div class="no-child-data">
                          No transaction data for this step.
                        </div>
}
                      </div>
                    </td>
                  </tr>
}
                
}
              </tbody>
            </table>
          </div>
        </div>
}

        <!-- Empty step data message -->
        @if (!tableLoading && tableIndex === 0 && transByStepData.length === 0 && selectedProject) {
<div class="project-details-no-selection flex-center"
            >
          <span>No transaction steps found for this project.</span>
        </div>
}

        <!-- ====== TAB 1: Transaction Data ====== -->
        @if (!tableLoading && tableIndex === 1 && transData.length > 0) {
<div class="project-review-datatable">
          <div class="grid-wrapper">
            <table class="table table-bordered table-hover project-table">
              <thead>
                <tr>
                  <th style="width: 70px; cursor: pointer;" (click)="sortTransTable('entity_details')">
                    Leid/CDR No/Rep Pd
                    <i class="fa" [ngClass]="transSortColumn === 'entity_details' ? (transSortAsc ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'" style="margin-left: 4px;"></i>
                  </th>
                  <th style="width: 200px; cursor: pointer;" (click)="sortTransTable('le_name')">
                    Entity Name
                    <i class="fa" [ngClass]="transSortColumn === 'le_name' ? (transSortAsc ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'" style="margin-left: 4px;"></i>
                  </th>
                  <th style="width: 40px;" class="text-center">BSLA</th>
                  <th style="width: 40px;" class="text-center">Source</th>
                  <th style="width: 200px;">Adj. Desc</th>
                  <th style="width: 200px;">Usr. Desc</th>
                  <th style="width: 30px;" class="text-center">Curr.</th>
                  <th style="width: 10px;" class="text-center">FG</th>
                  <th style="width: 80px; cursor: pointer;" (click)="sortTransTable('amount')">
                    Amount - Incr/ (Decr)
                    <i class="fa" [ngClass]="transSortColumn === 'amount' ? (transSortAsc ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'" style="margin-left: 4px;"></i>
                  </th>
                  <th style="width: 30px;">Docs</th>
                  <th style="width: 300px;">DST</th>
                </tr>
              </thead>
              <tbody>
                @for (row of transData; track $index; let odd = $odd) {
<tr [ngClass]="{'table-even-clr': odd}">
                  <td class="data-column">{{row.entity_details}}</td>
                  <td class="data-column">{{row.le_name}}</td>
                  <td class="data-column text-center">{{row.me_code}}</td>
                  <td class="data-column text-center">{{row.source_system_flag}}</td>
                  <td class="data-column">{{row.adj_desc}}</td>
                  <td class="data-column">{{row.user_desc}}</td>
                  <td class="data-column text-center">{{row.curr}}</td>
                  <td class="data-column text-center">{{row.consol_group_key}}</td>
                  <td class="data-column">
                    <span [ngClass]="{'amount-negative': isNegative(row.amount)}" class="datatable-revenue">
                      {{formatAmount(row.amount)}}
                    </span>
                  </td>
                  <td class="data-column">
                    @if (row.source_system_flag !== 'DST' && row.doc_key) {
<span class="doc-icon text-right"
                         
                          (click)="downloadDocument(row.doc_key)">
                      <i class="fa fa-paperclip doc-download"></i>
                    </span>
}
                  </td>
                  <td class="data-column text-link">
                    @if (row.statement_name) {
<a [href]="getDstLink(row)">
                      &sect;&nbsp;{{row.statement_name}}
                    </a>
}
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
}

        <!-- Empty transaction data message -->
        @if (!tableLoading && tableIndex === 1 && transData.length === 0 && selectedProject) {
<div class="project-details-no-selection flex-center"
            >
          <span>No transaction data found for this project.</span>
        </div>
}

      </div>
}
    </div>
  </div>
</div>
